const __request = require(`./__request_contentType_form`);
module.exports = __request;
